import Dashboard from 'routes/Dashboard'
import api, { getUserFromCtx } from 'shared/api'

const defaultProps = {}
const propTypes = {}

export async function getServerSideProps(context) {
  const user = getUserFromCtx(context)
  const host =
    context.req.headers['x-forwarded-host'] || context.req.headers.host
  const { query } = context
  const { post: postId } = query

  try {
    if (!postId) {
      return {
        props: {
          host,
          user,
        },
      }
    }

    const postResquests = [
      api.get(`/public/posts/${postId}`),
      api.get('/comments?page=1&limit=10', {
        headers: {
          Authorization: `Bearer ${user?.accessToken}`,
        },
        params: {
          type: 'Post',
          reference: postId,
        },
      }),
    ]

    const [
      { data: postData },
      { data: commentsList, headers: { 'x-total-results': commentCount } = {} },
    ] = await Promise.all(postResquests)

    const { data: isLiked } = user?.accessToken
      ? await api.get(`/posts/liked/${postId}`, {
          headers: { Authorization: `Bearer ${user?.accessToken}` },
        })
      : { data: false }

    return {
      props: {
        host,
        user,
        postData: {
          ...postData,
          isLiked: isLiked || null,
          commentsData: {
            list: commentsList || [],
            total: commentCount || 0,
          },
        },
        seoConfig: {
          image: postData?.image || null,
          title: postData?.text || null,
          content: postData?.text || null,
        },
      },
    }
  } catch (e) {
    return {
      props: {
        errorCode: 404,
      },
    }
  }
}

export const Page = props => <Dashboard {...props} />

Page.defaultProps = defaultProps
Page.propTypes = propTypes

export default Page
